if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
               cartPopupUpdate()
                // setTimeout(()=> {
                //     document.body.classList.add('cart-popup-active')
                //     document.body.classList.add('dropdown-shadow')
                // },500)
              // window.location = window.routes.cart_url;
              // return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

let temp_produc = document.querySelector('body.product')
if(temp_produc){
// show first desc on load
let opt_one_desc = document.querySelectorAll('.opiton_1_description')
let def_desc = document.querySelectorAll('.default_desc')
let all_des = document.querySelectorAll('.variant_desc');
    all_des.forEach((des)=>{
     des.style.display = 'none'
   })

opt_one_desc.forEach((first_desc)=>{
  if(first_desc != null){
  first_desc.style.display = 'block';
}else{
  first_desc.style.display = 'block'
}
})

}
// variant change title
let input_options = document.querySelectorAll('.product-form__input input');
input_options.forEach((inputs)=>{
  inputs.addEventListener('click',(input)=>{
     let target = input.target;
     let checked_title = target.getAttribute('value');
     // variant descripiton
     let opt_one_desc = document.querySelectorAll('.opiton_1_description')
     let opt_two_desc = document.querySelectorAll('.opiton_2_description')
     let opt_three_desc = document.querySelectorAll('.opiton_3_description')
     let all_desc = document.querySelectorAll('.variant_desc');
     all_desc.forEach((des)=>{
       des.style.display = 'none'
     })
     let index = target.getAttribute('index');
     // prod_tit.innerText = checked_title;

     opt_one_desc.forEach((first_desc)=>{
       if(index == '1' && first_desc != null){
       first_desc.style.display = 'block';
       }
     })

     opt_two_desc.forEach((scnd_desc)=>{
       if(index == '2' && scnd_desc != null){
       scnd_desc.style.display = 'block';
       }
     })
     opt_three_desc.forEach((thrd_desc)=>{
       if(index == '3' && thrd_desc != null){
       thrd_desc.style.display = 'block';
       }
     })
     // if(index == '1' && opt_one_desc != null){
     //   opt_one_desc.style.display = 'block';
     // }else if(index == '2' && opt_two_desc != null){
     //   opt_two_desc.style.display = 'block';
     // }else if(index == '3' && opt_three_desc != null){
     //   opt_three_desc.style.display = 'block'
     // }else{
     //   def_desc.style.display = 'block'
     // }
     // end
  })
})

// product bundles
// product accordions

let inputs = document.querySelectorAll('.product__accordion input');
let first_input = document.querySelector('.product__accordion input');
// select the first radio bundle
document.addEventListener('DOMContentLoaded', () => {
  // Select all product inputs and trigger click event for each
  inputs.forEach((input) => {
    input.click();
    input.classList.add('greyed');
    input.style.pointerEvents = 'none';
    input.style.accentColor = 'greyed';
  });

  // Rest of your existing code...
});

let inputs_length = inputs.length;
let imgs_width = 100 / inputs_length;

let target_append = document.querySelector('.product-bundle-images');
let priceArray = [];
const imageMap = new Map();

inputs.forEach((input) => {
  input.addEventListener('click', (e) => {
    let input = e.target;

    async function array_update() {
      let checked_inputs = document.querySelectorAll('.product__accordion input:checked');
      let checked_count = checked_inputs.length;

      if (checked_count >= 2) {
        inputs.forEach((input) => {
          input.classList.remove('greyed');
          input.style.pointerEvents = null;
          input.style.accentColor = null;
        });
      } else {
        inputs.forEach((input) => {
          if (input.checked) {
            input.classList.add('greyed');
            input.style.pointerEvents = 'none';
            input.style.accentColor = 'greyed';
          }
        });
      }

      let sum = 0;

      // Clear the target_append before re-adding images
      target_append.innerHTML = '';

      for (let i = 0; i < checked_inputs.length; i++) {
        let input = checked_inputs[i];
        let integ_price = parseInt(input.getAttribute('price') / 100);
        sum += integ_price;

        if (input.checked) {
          let new_img = document.createElement('img');
          new_img.style.width = imgs_width + '%';
          new_img.src = `${input.getAttribute('img')}`;
          new_img.classList.add('image-fade');

          target_append.appendChild(new_img);
          new_img.getBoundingClientRect();
          new_img.style.opacity = 1;
        }
      }

      document.querySelector('.product_bundle_price').textContent = `SAR ${sum}.00`;
    }

    // Add a delay to ensure the input state is updated before array_update is called
    setTimeout(array_update, 0);
  });
});

// add to cart button
let btn = document.querySelector('#ProductSubmitButton-template--16394924916936__main, #ProductSubmitButton-template--16394924884168__main');
let variant_Array = [];
if (btn) {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    variant_Array = [];
    inputs.forEach((e) => {
      let input = e;
      if (input.checked) {
        let id = parseInt(input.getAttribute('value'));
        let quantity = 1;
        let maxQuantity = parseInt(input.getAttribute('max_quantity'));
        variant_Array.push({ id, quantity, properties: { maxQuantity: maxQuantity } });
      }
    });
    multiple_cart(variant_Array);
  });
}
